import { getReactHookFormNestedError } from "../../utils/errors";

export const isPreActivationFieldErrorVisible = ({
  isTouched = false,
  isDirty = false,
  formState = {},
} = {}) =>
  Boolean(
    formState.isSubmitted ||
      (formState.submitCount ?? 0) > 0 ||
      isTouched ||
      isDirty
  );

export const getVisibleFieldErrorMessage = (fieldState = {}, formState = {}) => {
  if (!fieldState?.error?.message) return "";
  if (
    !isPreActivationFieldErrorVisible({
      isTouched: fieldState.isTouched,
      isDirty: fieldState.isDirty,
      formState,
    })
  ) {
    return "";
  }
  return fieldState.error.message;
};

export const getVisibleFormErrorsForField = ({
  errors,
  name,
  formState,
} = {}) => {
  const fieldError = getReactHookFormNestedError(errors, name);
  if (!fieldError) return {};

  const isTouched = Boolean(
    getReactHookFormNestedError(formState?.touchedFields, name)
  );
  const isDirty = Boolean(
    getReactHookFormNestedError(formState?.dirtyFields, name)
  );

  if (
    !isPreActivationFieldErrorVisible({
      isTouched,
      isDirty,
      formState,
    })
  ) {
    return {};
  }

  return errors;
};
